import { format } from 'date-fns';
/**
 * A wrapper around a date library format function (currently date-fns format).
 *
 * @category Formatting helpers.
 *
 * @param {Date | string} date - The date to format.
 * @param {DateFormats | DateStyle} dateFormat - The formatting tokens.
 * @returns {string} - The formatted date string.
 */
export const _baseFormat = (date, dateFormat) => {
    const dateToFormat = typeof date === 'string' ? new Date(date) : date;
    return format(dateToFormat, dateFormat);
};
//# sourceMappingURL=base-format.js.map